import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'notificationStatusColor'
})
export class NotificationStatusColorPipe implements PipeTransform {
  transform(logLevel: number): string {
    if (logLevel === 4) {
      return 'notification-error';
    } else if (logLevel === 3) {
      return 'notification-warning';
    } else {
      return '';
    }
  }
}
